import Vue from 'vue'
import VueTheMask from 'vue-the-mask'

export default function ({ app }) {
  Vue.use(VueTheMask)
}
